import { Exception } from "../../Exceptions/Exception";
import { SqlParser } from "../../Parsers/SQL/SqlParser";
import ConnectionStringUtils from "../../Utils/ConnectionStringUtils";
import NumberUtils from "../../Utils/NumberUtils";
import SqlType from "../../Utils/SqlType";
import StringBuilder from "../../Utils/StringBuilder";
import StringUtils from "../../Utils/StringUtils";
import TextUtils from "../../Utils/TextUtils";
import { Utils } from "../../Utils/Utils";
import XoneJSONConnection from "../JSONConnection/XoneJSONConnection";
import XoneWebCoreResulset from "./XoneWebCoreResulset";
export default class XoneWebCoreConnection {
    /**
     *
     */
    constructor(sConnectionString) {
        this.m_token = null;
        // Unos valore por defecto
        this.m_idsUrl = "https://ids.xonedev.cloud/connect/token";
        this.sUrlAddress = "https://web.xonedev.cloud/api/itf/DoAction";
        this.sUrlAddressUpload = "https://web.xonedev.cloud/api/itf/Upload";
        this.sUrlAddressDownload = "https://web.xonedev.cloud/api/itf/Download";
        this.sRowidFieldName = "ROWID";
        this.sDateMask = "ymd";
        this.parseConnectionString(sConnectionString);
    }
    executeUpdateAsync(Sentence) {
        throw new Error("Method not implemented.");
    }
    async executeNonQuery(login, password, data) {
        var token = await this.readBearerTokenAsync(login, password);
        if (TextUtils.isEmpty(token))
            throw new Exception("No Auth");
        // var parser=new SqlParser("ROWID");
        // parser.ParseSqlString(Sentence as string);
        // var data= {
        //     coll: args[0],
        //     action: "select",
        //     where: parser.GetWhereSentence()
        // };
        const response = await fetch(this.sUrlAddress, {
            method: "POST",
            //mode: 'no-cors', // no-cors, *cors, same-origin
            // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            //credentials: 'omit', // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            //redirect: 'follow', // manual, *follow, error
            // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data),
        });
        const result = await response.json();
        if (result.hasError === true)
            throw new Exception(result.err);
        return result;
    }
    getDataFromParser(parser) {
        // amiyares 20/08/2021: reemplazo el valor "NULL" por null
        const data = parser.GetFields().toJSON();
        Object.entries(data).forEach(([key, value]) => {
            if (value === "NULL")
                data[key] = null;
        });
        return data;
    }
    formatOnlineData(parser, collName, keys) {
        if (parser.GetSqlType() == SqlType.SQLTYPE_SELECT) {
            return {
                coll: collName,
                action: "select",
                where: parser.GetWhereSentence(),
            };
        }
        if (parser.GetSqlType() == SqlType.SQLTYPE_UPDATE || parser.GetSqlType() == SqlType.SQLTYPE_INSERT) {
            return {
                coll: collName,
                action: "write",
                data: this.getDataFromParser(parser),
                keys: parser.getKeys(),
                where: parser.GetWhereSentence(),
            };
        }
        if (parser.GetSqlType() == SqlType.SQLTYPE_DELETE) {
            return {
                coll: collName,
                action: "drop",
                data: this.getDataFromParser(parser),
                keys: parser.getKeys(),
                where: null,
            };
        }
        return {};
        // if (parser.GetSqlType() == SqlType.SQLTYPE_INSERT) {
        //     return {
        //         coll: collName,
        //         action: "write",
        //         data: this.getDataFromParser(parser),
        //         keys: parser.getKeys(),
        //         data: this.getDataFromParser(parser)
        //     };
        // }
    }
    async executeAsync(Login, Password,Sentence, MaxRows, ...args) {
        if (typeof Sentence == "string") {
            let tmp = new SqlParser(this.sRowidFieldName);
            tmp.ParseSqlString(Sentence);
            Sentence = tmp;
        }
        return await this.executeNonQuery(Login, Password,this.formatOnlineData(Sentence, args[2], args[3]));
    }
    async uploadAsync(File, FileName) {
        var token = await this.readBearerTokenAsync();
        if (TextUtils.isEmpty(token))
            throw new Exception("No Auth");
        const fileName = FileName || `${Math.random().toString(36).substr(2, 9)}.png`;
        const formData = new FormData();
        formData.append("file", File, fileName);
        const response = await fetch(this.sUrlAddressUpload, {
            method: "POST",
            headers: {
                //"Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            //redirect: 'follow', // manual, *follow, error
            // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: formData,
        });
        const result = await response.json();
        if (result.hasError === true)
            throw new Exception(result.err);
        return result;
    }
    async downloadAsync(FileName) {
        var token = await this.readBearerTokenAsync();
        if (TextUtils.isEmpty(token))
            throw new Exception("No Auth");
        const fileName = FileName || `${Math.random().toString(36).substr(2, 9)}.png`;
        const response = await fetch(this.sUrlAddressDownload, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                'x-request-filename': fileName
            },
        });
        return response;
    }
    getAuthData(login,password) {
        var bld = new StringBuilder("login=");
        bld.append(login);
        bld.append("&password=");
        bld.append(password);
        //bld.append("&grant_type=client_credentials");
        return bld.toString();
    }
    async readBearerTokenAsync(login,password) {
        if (this.m_token != null) {
            if (this.m_token.expires_in > new Date())
                return this.m_token.access_token;
        }
        // if (this.sUrlAddress.indexOf('localhost') > 0)
        //     return 'FORTEST';
        const response = await fetch(this.m_idsUrl, {
            method: "POST",
            //mode: "no-cors",
            // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            // credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                //'Content-Type': 'application/json',
                "Content-Type": "application/x-www-form-urlencoded",
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: this.getAuthData(login,password),
        });
        let token = await response.json();
        if (token.error) {
            console.error(token.error);
            return (this.m_token = null);
        }
        var expire = new Date();
        expire.setSeconds(expire.getSeconds() + token.expires_in);
        this.m_token = token;
        this.m_token.expires_in = expire;
        return token.access_token;
        //   return response.then((value)=> {
        //     return value.json().then((token)=> {
        //         if (token.error) {
        //             console.error(token.error);
        //             return this.m_token=null;
        //         }
        //         var expire=new Date();
        //         expire.setSeconds(expire.getSeconds()+token.expires_in);
        //         this.m_token=token;
        //         this.m_token.expires_in=expire;
        //         return token.access_token;
        //     })
        //     .catch((reason)=>{
        //         console.error(reason);
        //         return null;
        //     }); // parses JSON response into native JavaScript objects
        //   })
        //   .catch((reason)=> {
        //       console.error(reason);
        //       throw new Exception(reason);
        //   })
    }
    executeQuery() {
        return new XoneWebCoreResulset();
    }
    clearToken() {
        this.m_token = null;
    };

    async fetchDataAsync(login, password,data) {
        var token = await this.readBearerTokenAsync(login, password); //
        if (TextUtils.isEmpty(token))
            throw new Exception("No Auth");
        // var parser = new SqlParser("ROWID");
        // parser.ParseSqlString(Sentence as string);
        // var data = {
        //     //count:args.length>0?args[0]:false,
        //     //coll: args.length>1?args[1]:"",
        //     action: "select",
        //     where: parser.GetWhereSentence(),
        //     sort: parser.getOrderBySentence()
        //     //page: args.length>2?args[2]:{}
        // };
        // data = { ...data, ...options };
        const response = await fetch(this.sUrlAddress, {
            method: "POST",
            //mode: 'no-cors', // no-cors, *cors, same-origin
            // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            //credentials: 'omit', // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            //redirect: 'follow', // manual, *follow, error
            // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data),
        });
        return await response.json();
    }
    async executeQueryAsync(Login, Password,Sentence, ...args) {
        // var parser = new SqlParser("ROWID");
        // parser.ParseSqlString(Sentence as string);
        var data = {
            action: "select",
        };
        data = Object.assign(Object.assign({}, data), args[0]);
        var rs = new XoneWebCoreResulset(this, data);
        return await rs.populate(Login, Password);
    }
    // async executeQueryAsyncOld(Sentence: any, ...args): Promise<IResultSet> {
    //     var token = await this.readBearerTokenAsync();
    //     if (TextUtils.isEmpty(token))
    //         throw new Exception("No Auth");
    //     var parser = new SqlParser("ROWID");
    //     parser.ParseSqlString(Sentence as string);
    //     var data = {
    //         //count:args.length>0?args[0]:false,
    //         //coll: args.length>1?args[1]:"",
    //         action: "select",
    //         where: parser.GetWhereSentence(),
    //         sort: parser.getOrderBySentence()
    //         //page: args.length>2?args[2]:{}
    //     };
    //     this.m_data = { ...data, ...args[0] };
    //     const response = await fetch(this.m_url, {
    //         method: 'POST', // *GET, POST, PUT, DELETE, etc.
    //         //mode: 'no-cors', // no-cors, *cors, same-origin
    //         // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    //         //credentials: 'omit', // include, *same-origin, omit
    //         headers: {
    //             'Content-Type': 'application/json',
    //             "Authorization": "Bearer " + token
    //             // 'Content-Type': 'application/x-www-form-urlencoded',
    //         },
    //         //redirect: 'follow', // manual, *follow, error
    //         // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    //         body: JSON.stringify(this.m_data) // body data type must match "Content-Type" header
    //     });
    //     const result = await response.json();
    //     return this.m_resulset = new XoneWebCoreResulset(result.data);
    //     // return this.readBearerTokenAsync().then((token) => {
    //     //     if (TextUtils.isEmpty(token))
    //     //         throw new Exception("No Auth");
    //     //     var parser=new SqlParser("ROWID");
    //     //     parser.ParseSqlString(Sentence as string);
    //     //     var data= {
    //     //         coll: args[0],
    //     //         action: "select",
    //     //         where: parser.GetWhereSentence()
    //     //     };
    //     //     const response = fetch(this.m_url, {
    //     //         method: 'POST', // *GET, POST, PUT, DELETE, etc.
    //     //         mode: 'no-cors', // no-cors, *cors, same-origin
    //     //         // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    //     //         //credentials: 'omit', // include, *same-origin, omit
    //     //         headers: {
    //     //         'Content-Type': 'application/json',
    //     //         "Authorization": "Bearer "+token
    //     //         // 'Content-Type': 'application/x-www-form-urlencoded',
    //     //         },
    //     //         //redirect: 'follow', // manual, *follow, error
    //     //         // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    //     //         body: JSON.stringify(data) // body data type must match "Content-Type" header
    //     //     });
    //     //     return response.then((value)=>
    //     //             value.json().then((result)=>
    //     //                 new XoneWebCoreResulset(result.data)))
    //     //             .catch((reason)=> {
    //     //                 console.error(reason);
    //     //                 return null;
    //     //             });
    //     // });
    // }
    async countAsync(...args) {
        // var token = await this.readBearerTokenAsync();
        // if (TextUtils.isEmpty(token))
        //     throw new Exception("No Auth");
        // var parser = new SqlParser("ROWID");
        // parser.ParseSqlString(Sentence as string);
        var data = {
            action: "count",
        };
        data = Object.assign(Object.assign({}, data), args[0]);
        var rs = new XoneWebCoreResulset(this, data);
        return await rs.populate();
        // const response = await fetch(this.m_url, {
        //     method: 'POST', // *GET, POST, PUT, DELETE, etc.
        //     //mode: 'no-cors', // no-cors, *cors, same-origin
        //     // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        //     //credentials: 'omit', // include, *same-origin, omit
        //     headers: {
        //         'Content-Type': 'application/json',
        //         "Authorization": "Bearer " + token
        //         // 'Content-Type': 'application/x-www-form-urlencoded',
        //     },
        //     //redirect: 'follow', // manual, *follow, error
        //     // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        //     body: JSON.stringify(this.m_data) // body data type must match "Content-Type" header
        // });
        // const result = await response.json();
        // return this.m_resulset = new XoneWebCoreResulset(result.data);
    }
    /**
     * Expone o asigna valor al campo ROWID de la base de datos que se va a usar
     *
     * @return Devuelve el nombre del campo ROWID para esta conexión.
     */
    getRowIdFieldName() {
        return this.sRowidFieldName;
    }
    getDatemask() {
        return this.sDateMask;
    }
    parseConnectionString(sConnection) {
        let parameters = ConnectionStringUtils.parseConnectionString(sConnection);
        this.bIsLoginCall = StringUtils.ParseBoolValue(parameters.get("logincall"));
        // TAG 20050201: Luis: Permitir una primera aproximacion a authorization por JWT
        // En el connstring debe ponerse jwtcall=true y el token que se tenga
        this.bIsJWTCall = StringUtils.ParseBoolValue(parameters.get("jwtcall"));
        this.sToken = StringUtils.SafeToString(parameters.get("token"), Utils.EMPTY_STRING);
        this.nFlags =
            this.nFlags |
                (StringUtils.ParseBoolValue(parameters.get("odataformat")) ? XoneJSONConnection.FLAG_XONEJSONODATA : XoneJSONConnection.FLAG_XONEJSONSQL);
        this.nFlags =
            this.nFlags |
                (StringUtils.ParseBoolValue(parameters.get("customformat")) ? XoneJSONConnection.FLAG_XONEJSONCUSTOM : XoneJSONConnection.FLAG_XONEJSONSQL);
        this.nTimeout = NumberUtils.SafeToInt(parameters.get("timeout"), 60);
        this.nSecurityLevel = NumberUtils.SafeToInt(parameters.get("security level"), 0);
        this.sUrlAddressUpload = parameters.get("upload");
        if (this.sUrlAddressUpload != null) {
            this.sUrlAddressUpload = this.sUrlAddressUpload.trim();
            if (this.sUrlAddressUpload.endsWith("?")) {
                this.sUrlAddressUpload = this.sUrlAddressUpload.substring(0, this.sUrlAddress.length - 1);
            }
        }
        else {
            this.sUrlAddressUpload = Utils.EMPTY_STRING;
        }
        this.sUrlAddressDownload = parameters.get("download");
        if (this.sUrlAddressDownload != null) {
            this.sUrlAddressDownload = this.sUrlAddressDownload.trim();
            if (this.sUrlAddressDownload.endsWith("?")) {
                this.sUrlAddressDownload = this.sUrlAddressDownload.substring(0, this.sUrlAddressDownload.length - 1);
            }
        }
        else {
            this.sUrlAddressDownload = Utils.EMPTY_STRING;
        }
        this.sUrlAddress = parameters.get("data source");
        if (this.sUrlAddress != null) {
            this.sUrlAddress = this.sUrlAddress.trim();
            if (this.sUrlAddress.endsWith("?")) {
                this.sUrlAddress = this.sUrlAddress.substring(0, this.sUrlAddress.length - 1);
            }
        }
        else {
            this.sUrlAddress = Utils.EMPTY_STRING;
        }
        this.m_idsUrl = parameters.get("ids") || this.m_idsUrl;
        this.sRowidFieldName = parameters.get("rowidfieldname") || this.sRowidFieldName;
        this.sDateMask = parameters.get("datemask") || this.sDateMask;
        //this.m_url=this.sUrlAddress;
        this.sMethod = parameters.get("method");
        if (this.sMethod == null) {
            this.sMethod = "POST";
        }
        this.sUsername = parameters.get("xoneuser");
        if (this.sUsername == null) {
            this.sUsername = Utils.EMPTY_STRING;
        }
        this.sPassword = parameters.get("xonepass");
        if (this.sPassword == null) {
            this.sPassword = Utils.EMPTY_STRING;
        }
        this.sEndpoint = parameters.get("endpoint");
        if (this.sEndpoint == null) {
            this.sEndpoint = Utils.EMPTY_STRING;
        }
        // TAG 20050208: Luis: Permitir customizar mas las colecciones online
        // en el connstring se puede poner Action=nombreaccion y AuthAction=nombreaccionauth
        this.sAction = StringUtils.SafeToString(parameters.get("action"), XoneJSONConnection.DEFAULT_ACTION_NAME);
        this.sAuthAction = StringUtils.SafeToString(parameters.get("authaction"), XoneJSONConnection.DEFAULT_AUTHACTION_NAME);
        this.sContentType = StringUtils.SafeToString(parameters.get("content-type"), XoneJSONConnection.DEFAULT_CONTENT_TYPE);
        this.bIsSqlQuery = StringUtils.ParseBoolValue(parameters.get("sqlquery"), true);
        // TAG: 0604201601 nuevo parametro en el connstring para poder codeficar el cupero del post en formato key=valeu&key=vale
        this.bPostUrlEncode = StringUtils.ParseBoolValue(parameters.get("postencode"), false);
        this.bIsCertificatePinningEnabled = StringUtils.ParseBoolValue(parameters.get("enablecertificatepinning"));
        this.sLocalCertPath = StringUtils.SafeToString(parameters.get("localcertificatepath"));
        // Para la autenticacion remota, puede ser por conexion o por llamada del script del metodo
        this.bAuthenticate = StringUtils.ParseBoolValue(parameters.get("auth"), false);
        if (this.bAuthenticate) {
            this.sAuthenticationUsername = parameters.get("user id");
            this.sAuthenticationPassword = parameters.get("password");
        }
        this.bUseRemoteBroker = StringUtils.ParseBoolValue(parameters.get("remote broker"), false);
        this.sRemoteMapped = StringUtils.SafeToString(parameters.get("remote mapped"));
        this.sRemoteDest = StringUtils.SafeToString(parameters.get("remote destination"));
        this.bAllowUnsafeCertificates = StringUtils.ParseBoolValue(parameters.get("allowunsafecertificates"), false);
    }
    createStatement() {
        throw new Error("Method not implemented.");
    }
    isClosed() {
        throw new Error("Method not implemented.");
    }
    commit() {
        throw new Error("Method not implemented.");
    }
    beginTrans() {
        throw new Error("Method not implemented.");
    }
    rollback() {
        throw new Error("Method not implemented.");
    }
    execute(parameter, MaxRows) {
        throw new Error("Method not implemented.");
    }
    executeUpdate(Sentence) {
        return 0;
    }
    executeOperation(OperType, tableName, values, whereClause) {
        throw new Error("Method not implemented.");
    }
    getDBMS() {
        throw new Error("Method not implemented.");
    }
    outerJoinsSupported() {
        throw new Error("Method not implemented.");
    }
    acceptsParsedSentences() {
        throw new Error("Method not implemented.");
    }
    acceptsEmptyQueries() {
        throw new Error("Method not implemented.");
    }
    LastRowsAffected() {
        throw new Error("Method not implemented.");
    }
    LastInsertedRowId() {
        throw new Error("Method not implemented.");
    }
    cancelProcesses(flags) {
        throw new Error("Method not implemented.");
    }
    setCryptoData(cryptoData) {
        throw new Error("Method not implemented.");
    }
    getCryptoData() {
        throw new Error("Method not implemented.");
    }
    cryptoSupported() {
        throw new Error("Method not implemented.");
    }
    getTokenFromAuth(login, pass) {
        throw new Error("Method not implemented.");
    }
}

//# sourceMappingURL=XoneWebCoreConnection.js.map
